import React, { useState } from 'react';
import { TextField, Typography } from '@mui/material';

import { OnboardingWrapper } from '../../../components';
import { useAuthContext, useOnboarding } from '../../../data-access';

import './NameEntryPage.scss';

export const NameEntryPage: React.FC = () => {
  const { currentOnboardingStep, goToNextStep, goToPreviousStep } = useOnboarding();
  const { user, updateUser, isUpdatingUser, isUserFetching } = useAuthContext();
  const [name, setName] = useState(user?.name ?? '');

  const handleContinue = async () => {
    const trimmedName = name.trim();
    if (!trimmedName || !user?.userId) {
      return;
    }

    if (trimmedName !== user?.name) {
      await updateUser({ name: trimmedName });
    }

    goToNextStep();
  };

  return (
    <OnboardingWrapper
      currentOnboardingStep={currentOnboardingStep}
      onBack={goToPreviousStep}
      title="What should we call you?"
      buttons={[
        {
          text: 'Continue',
          onPress: handleContinue,
          variant: 'contained',
          disabled: !name.trim() || !user?.userId || isUserFetching,
          loading: isUpdatingUser,
        },
      ]}
    >
      <div className="name-entry-page">
        <TextField
          className="name-entry-page__input"
          placeholder="Enter your name"
          variant="outlined"
          fullWidth
          value={name}
          autoFocus
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              void handleContinue();
            }
          }}
          inputProps={{ maxLength: 50 }}
        />
      </div>
    </OnboardingWrapper>
  );
};
